// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextIfr } from '../../Project.context';

// hooks
import { useIfr } from '../../../../../hooks/useIfr';

// mui
import { Container, Grid } from '@mui/material';

// pages
import { IfrAlert } from '../IfrAlert/IfrAlert';

// ui
import { TableSheet } from '../../../../ui/TableSheet/TableSheet';

export const Components = () => {
	// hooks
	const { handleClickCell } = useIfr();
	const { t } = useTranslation();

	// context
	const { ifr, ifrTables } = useContext(ContextIfr);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Container maxWidth={false}>
					<Grid container spacing={2}>
						{!ifr?.ifrPlan && ifr?.status === 'DRAFT' && (
							<Grid item xs={12}>
								<IfrAlert type="IFR_PLAN_NON_EXISTENT" />
							</Grid>
						)}
						<Grid item xs={12}>
							<TableSheet
								columns={ifrTables?.cashOutComponents?.columns || []}
								isExpandable={false}
								label={t('tableSheets.cashOutComponents.title')}
								onClickCell={handleClickCell}
								palette={ifrTables?.cashOutComponents?.palette}
								rows={ifrTables?.cashOutComponents?.rows || []}
							/>
						</Grid>
						<Grid item xs={12}>
							<TableSheet
								columns={ifrTables?.reimbursementComponents?.columns || []}
								isExpandable={false}
								label={t('tableSheets.reimbursementComponents.title')}
								palette={ifrTables?.reimbursementComponents?.palette}
								rows={ifrTables?.reimbursementComponents?.rows || []}
							/>
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</Grid>
	);
};
